import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.REPORTS_QUALITY_CONTROLS].GET_REPORTS_QUALITY_CONTROLS]: {
		url: '/company/:companyId/reports/quality_control/',
	},
	[ModulesConfigMap[ModulesMap.REPORTS_QUALITY_CONTROLS].GET_REPORTS_QUALITY_CONTROL]: {
		url: '/company/:companyId/reports/quality_control/:qualityControlId/',
	},
  [ModulesConfigMap[ModulesMap.REPORTS_QUALITY_CONTROLS].GET_REPORTS_QUALITY_CONTROL_PREVIEW]: {
		url: '/company/:companyId/reports/quality_control/:qualityControlId/preview/',
	},
}